import moment from "moment";

export function findStringById(arr, idField, idValue) {
  return arr.find((obj) => {
    return obj[idField] === idValue;
  });
}

export function findIdByString(arr, idField, idValue) {
  return arr.find((obj) => {
    return obj[idField]?.toLowerCase() === idValue?.toLowerCase();
  });
}

export function isValidCharacters(strObj) {
  const regex_symbols = /^[a-zA-Z0-9!@#$^%&*()_+\n\-=;':"|,.? ]*$/g;
  return regex_symbols.test(strObj);
}

export function validateEmail(inputEmail) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
  return emailRegex.test(inputEmail);
}

export function isValidTime24Hour(timeString) {
  const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  return regex.test(timeString);
}

export function formatDateUS(inputDate) {
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  const parsedDate = new Date(inputDate);

  return parsedDate.toLocaleString("en-US", options);
}

export function formatDateISOWithHyphen(inputDate) {
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  const parsedDate = new Date(inputDate);

  return (
    parsedDate.getFullYear() +
    "-" +
    (parsedDate.getMonth() + 1) +
    "-" +
    parsedDate.getDate()
  );
}

export function convertStringIntoUSDate(inputDate) {
  return (
    inputDate.substring(4, 6) +
    "-" +
    inputDate.substring(6, 8) +
    "-" +
    inputDate.substring(0, 4)
  );
}

export function formatDateTimeUS(inputDate) {
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const parsedDate = new Date(inputDate);

  return parsedDate.toLocaleString("en-US", options);
}

export function getDateString(date) {
  let myDate = new Date(date);
  return (
    myDate.getFullYear() +
    "-" +
    ("0" + (myDate.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + myDate.getDate()).slice(-2) +
    "T" +
    ("0" + myDate.getHours()).slice(-2) +
    ":" +
    ("0" + myDate.getMinutes()).slice(-2) +
    ":" +
    ("0" + myDate.getSeconds()).slice(-2)
  );
}

export function findDuplicates(array, key) {
  const counts = {};
  const duplicates = [];

  array.forEach((item) => {
    const value = item[key];
    counts[value] = (counts[value] || 0) + 1;
  });

  for (const value in counts) {
    if (counts[value] > 1) {
      duplicates.push(value);
    }
  }

  return duplicates;
}

export function emptyValues(array) {
  return array.filter((item) => {
    const values = Object.values(item);

    return values.some(
      (value) => value === null || value === undefined || value === ""
    );
  });
}

export function getSunday(d) {
  d = new Date(d);
  const curr = new Date(d);
  const day = d.getDay(),
    diff = d.getDate() - day + (day == 0 ? -7 : 0); // adjust when day is sunday

  if (day === 0) {
    return curr;
  }

  return new Date(d.setDate(diff));
}

export function getFormattedDate(date) {
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  return month + "/" + day + "/" + year;
}

export function setStartEndDates(start, end) {
  // Parse dates as UTC to avoid timezone shifting
  // This ensures the date stays the same regardless of local timezone
  const parseDateAsUTC = (dateVal) => {
    if (!dateVal) return moment.utc();
    const dateStr = String(dateVal);
    // For ISO strings with time, parse directly
    if (dateStr.includes('T')) {
      return moment.utc(dateStr);
    }
    // Try multiple date formats - InputDate uses YYYY-MM-DD, some code uses MM/DD/YYYY
    let m = moment.utc(dateStr, ["YYYY-MM-DD", "MM/DD/YYYY"], true);
    if (!m.isValid()) {
      m = moment.utc(dateStr);
    }
    return m;
  };

  const startMoment = parseDateAsUTC(start);
  const endMoment = parseDateAsUTC(end);

  return {
    startDate: startMoment.format("MM/DD/YYYY"),
    endDate: endMoment.format("MM/DD/YYYY"),
    startDateTime: " 12:00 AM",
    endDateTime: " 11:59 PM",
  };
}

export function dateRangeFromSelectedOption(durationType, optionType) {
  if (durationType === "" || durationType === "Specified") {
    return;
  }
  const d = new Date();
  const dv = {
    day: getFormattedDate(d),
    month: d.getMonth(),
    year: d.getFullYear(),
    monday: "",
    sunday: "",
    quarterStart: "",
    quarterEnd: "",
    firstDayOfMonth: "",
    lastDayOfMonth: "",
  };

  d.setHours(0, 0, 0, 0);

  if (durationType === "Current") {
    const tempMonday = getSunday(new Date());
    const tempSunday = getSunday(new Date());
    dv.monday = tempMonday.setDate(tempMonday.getDate());
    dv.sunday = tempSunday.setDate(tempMonday.getDate() + 6);
    dv.firstDayOfMonth = getFormattedDate(new Date(dv.year, dv.month, 1));
    dv.lastDayOfMonth = getFormattedDate(new Date(dv.year, dv.month + 1, 0));

    if (dv.month < 3) {
      dv.quarterStart = "01/01/" + dv.year;
      dv.quarterEnd = "03/31/" + dv.year;
    } else if (dv.month > 2 && dv.month < 6) {
      dv.quarterStart = "04/01/" + dv.year;
      dv.quarterEnd = "06/30/" + dv.year;
    } else if (dv.month > 5 && dv.month < 9) {
      dv.quarterStart = "07/01/" + dv.year;
      dv.quarterEnd = "09/30/" + dv.year;
    } else if (dv.month > 8) {
      dv.quarterStart = "10/01/" + dv.year;
      dv.quarterEnd = "12/31/" + dv.year;
    }
  } else if (durationType === "Previous") {
    const prevDay = new Date();
    prevDay.setDate(prevDay.getDate() - 1);
    dv.day = getFormattedDate(new Date(prevDay));
    const tempMonday = getSunday(new Date());
    const tempSunday = getSunday(new Date());
    tempSunday.setDate(tempMonday.getDate() + 6);
    dv.monday = tempMonday.setDate(tempMonday.getDate() - 7);
    dv.sunday = tempSunday.setDate(tempSunday.getDate() - 7);
    dv.firstDayOfMonth = getFormattedDate(new Date(dv.year, dv.month - 1, 1));
    dv.lastDayOfMonth = getFormattedDate(new Date(dv.year, dv.month, 0));

    if (dv.month < 3) {
      dv.quarterStart = "10/01/" + (dv.year - 1);
      dv.quarterEnd = "12/31/" + (dv.year - 1);
    } else if (dv.month > 2 && dv.month < 6) {
      dv.quarterStart = "01/01/" + dv.year;
      dv.quarterEnd = "03/31/" + dv.year;
    } else if (dv.month > 5 && dv.month < 9) {
      dv.quarterStart = "04/01/" + dv.year;
      dv.quarterEnd = "06/30/" + dv.year;
    } else if (dv.month > 8) {
      dv.quarterStart = "07/01/" + dv.year;
      dv.quarterEnd = "09/30/" + dv.year;
    }
  }

  return getStartEndDate(durationType, optionType, dv);
}

function getStartEndDate(durationType, optionType, dv) {
  const tempDv = {
    startDate: "",
    endDate: "",
    startDateTime: " 12:00 AM",
    endDateTime: " 11:59 PM",
  };
  switch (optionType) {
    case "rbDay":
      tempDv.startDate = dv.day;
      tempDv.endDate = dv.day;
      break;
    case "rbWeek":
      tempDv.startDate = getFormattedDate(new Date(dv.monday));
      tempDv.endDate = getFormattedDate(new Date(dv.sunday));
      break;
    case "rbMonth":
      tempDv.startDate = dv.firstDayOfMonth;
      tempDv.endDate = dv.lastDayOfMonth;
      break;
    case "rbQuarter":
      tempDv.startDate = dv.quarterStart;
      tempDv.endDate = dv.quarterEnd;
      break;
    case "rbYear":
      tempDv.startDate =
        "01/01/" + (durationType === "Previous" ? dv.year - 1 : dv.year);
      tempDv.endDate =
        "12/31/" + (durationType === "Previous" ? dv.year - 1 : dv.year);
      break;
  }
  return tempDv;
}
